import { render, staticRenderFns } from "./CreateProductSlidingModal.vue?vue&type=template&id=6a18a847&scoped=true&"
import script from "./CreateProductSlidingModal.vue?vue&type=script&lang=js&"
export * from "./CreateProductSlidingModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductSlidingModal.vue?vue&type=style&index=0&id=6a18a847&prod&lang=scss&"
import style1 from "./CreateProductSlidingModal.vue?vue&type=style&index=1&id=6a18a847&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a18a847",
  null
  
)

export default component.exports